// Fashion Multi-Agent Models

import { ProviderAwareRequest } from './providerAware';

export interface MultiFashionRequest extends ProviderAwareRequest {
  designBrief: string;
  targetMarket?: string;
  season?: string;
  pricePoint?: string;
  themeElements?: string[];
  colorPalette?: string[];
  fabricPreferences?: string;
  includeSustainability?: boolean;
  iterations?: number;
  maxTokensPerAgentTurn?: number;
}

export interface MultiFashionResponse {
  sessionId?: string;
  trendAnalysis?: string;
  designConcept?: string;
  technicalSpecifications?: string;
}

export interface FashionSession {
  id: string;
  sessionId?: string; // Backend uses sessionId, map to id for compatibility
  userId?: string;
  status?: string;
  designBrief: string;
  targetMarket?: string;
  season?: string;
  pricePoint?: string;
  themeElements?: string[];
  colorPalette?: string[];
  fabricPreferences?: string;
  trendAnalysis?: string;
  designConcept?: string;
  technicalSpecifications?: string;
  createdAt: Date;
  lastUpdatedAt?: Date;
  expiresAt?: Date;
  includeSustainability?: boolean;
  iterations?: number;
  assetIds?: string[];
  assetCount?: number;
  assets?: Array<{
    id: string;
    assetType: string;
    subType: string;
    assetUrl: string;
    status: string;
    createdAt: string;
  }>;
}

export interface FashionSessionStorage {
  sessions: FashionSession[];
  lastUpdated: Date;
}

// Common options for UI
export const SEASONS = [
  'Spring/Summer',
  'Fall/Winter', 
  'Resort/Cruise',
  'Pre-Fall',
  'Year-Round'
];

export const TARGET_MARKETS = [
  'Luxury',
  'Contemporary',
  'Fast Fashion',
  'Athleisure',
  'Streetwear',
  'Business/Professional',
  'Evening/Formal',
  'Children',
  'Plus Size',
  'Sustainable/Eco'
];

export const PRICE_POINTS = [
  'Budget (Under $50)',
  'Affordable ($50-$150)',
  'Mid-Range ($150-$500)',
  'Premium ($500-$1,500)',
  'Luxury ($1,500-$5,000)',
  'Ultra-Luxury (Over $5,000)'
];

export const THEME_SUGGESTIONS = [
  'Minimalist',
  'Maximalist',
  'Vintage/Retro',
  'Futuristic',
  'Bohemian',
  'Classic/Timeless',
  'Avant-Garde',
  'Romantic',
  'Edgy/Punk',
  'Sporty',
  'Glamorous',
  'Utilitarian'
];

export const COLOR_SUGGESTIONS = [
  'Neutral Tones',
  'Earth Tones',
  'Jewel Tones',
  'Pastels',
  'Monochrome',
  'Bold & Bright',
  'Metallic Accents',
  'Black & White',
  'Seasonal Colors'
];